// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"f9c3bfbb","211":"4868bb2f","238":"6aad3a08","311":"3803fc6e","397":"a268dba8","413":"6443ef6e","467":"2d8900b2","479":"54297cb1","482":"6cbf5617","650":"d4294eee","743":"207d1ac4","815":"1238385b"}[chunkId] + ".chunk.js";
};